import {mapGetters} from 'vuex';
import propertyPop from '@/dpp/components/propertypop/property-pop.vue';

export default{
    name: 'propertyPop3d',
    components: {
        propertyPop
    },
    props:['pop3dUrl'],
    data(){
        return {
            url:'',
            loaded: false
        };
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['dpp'])
    },
    methods: {
        open(url){
            if(this.openInNewTab(url)){
                window.open(url, '_blank');
            }else{
                this.$refs.pop.open && this.$refs.pop.open();
                this.url = url;
            }
        },
        close(){
            this.$refs.pop.close();
        },
        excuted(){
            this.url = '';
        },
        openInNewTab(url){
            let _url = url && url.toLowerCase()
            return _url && (_url.includes('listingsmagic') || _url.includes('drive.google') || _url.includes('http://') || _url.startsWith('https://vimeo.com/'));
        },
        onload() {
            this.loaded = true
        },
    },
    mounted(){
        this.open(this.pop3dUrl);
    }
};
